/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Frames_TitleInputs */

const en_us2_exercise_sheet_frames_title = /** @type {(inputs: Exercise_Sheet_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start → Finish`)
};

const pt_br2_exercise_sheet_frames_title = /** @type {(inputs: Exercise_Sheet_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início → Fim`)
};

const es_419_exercise_sheet_frames_title = /** @type {(inputs: Exercise_Sheet_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio → Final`)
};

const pt_pt2_exercise_sheet_frames_title = /** @type {(inputs: Exercise_Sheet_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início → Fim`)
};

const fr_fr2_exercise_sheet_frames_title = /** @type {(inputs: Exercise_Sheet_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début → Fin`)
};

const de_de2_exercise_sheet_frames_title = /** @type {(inputs: Exercise_Sheet_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start → Ende`)
};

const it_it2_exercise_sheet_frames_title = /** @type {(inputs: Exercise_Sheet_Frames_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio → Fine`)
};

/**
* | output |
* | --- |
* | "Start → Finish" |
*
* @param {Exercise_Sheet_Frames_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_frames_title = /** @type {((inputs?: Exercise_Sheet_Frames_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Frames_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_frames_title(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_frames_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_frames_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_frames_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_frames_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_frames_title(inputs)
	return en_us2_exercise_sheet_frames_title(inputs)
});
export { exercise_sheet_frames_title as "exercise-sheet.frames_title" }